import React from 'react'
import { useOutletContext } from 'react-router-dom'
import type { HistoryOutletContext } from './ModernHistoryLayout'
import HistoryWalletReport from './HistoryWalletReport'

/** หน้า ประวัติการถอนเงิน */
const HistoryWithdrawPage: React.FC = () => {
  useOutletContext<HistoryOutletContext>()
  return <HistoryWalletReport mode="withdraw" />
}

export default HistoryWithdrawPage
